import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

import PageTitle from "../../components/PageTitle/PageTitle";
import ExpoCuponCard from "./ExpoCuponCard";

function ExpoCupon() {
    return (
        <div className="content-section">
            <div className="container">
                <PageTitle title={"博覽會特推優惠"} descriptionLines={["推薦給你喵喵的好朋友們,馬拉松博覽會一定要去找他們唷！"]} />
                <ExpoCuponCard />
            </div>
        </div>
    );
}

export default ExpoCupon;
